import React, { useState } from 'react'
import PhoneInput from 'react-phone-input-2'
import './styles.css'
import 'react-phone-input-2/lib/style.css'
import { T, TraksConsumer } from '../../traks'

const PhoneInp = ({ setPhoneNumber, className = "", initValue = "", required = false }) => {
	const [value, setValue] = useState(initValue);

	const targetValue = (phoneNumber) => {
		setValue(phoneNumber);
		setPhoneNumber(phoneNumber);
	}
	const Style = (props) => {
		const placeholder = props.render_static(<T>Phone</T>)
		return (
			<style>
				{`
					:root {
					  --new_sibilus_phone_content: '${placeholder}';
					}
				`}
			</style>
		)
	}

	return (<>
		<TraksConsumer>
			<Style />
		</TraksConsumer>
		<div className={`phone-input${className ? " " + className : ""}`} >
			<PhoneInput
				buttonClass="flag-dropdown"
				inputClass="w-100 d-flex bottom-0"
				country={'dk'}
				value={value}
				onChange={targetValue}
				onlyCountries={["dk", "se", "no", "de"]}
			/>
		</div>
	</>)
}

export default PhoneInp
